import { render } from "./editTotalWeightModal.vue?vue&type=template&id=345dd6b0&scoped=true&ts=true"
import script from "./editTotalWeightModal.vue?vue&type=script&lang=ts"
export * from "./editTotalWeightModal.vue?vue&type=script&lang=ts"

import "./editTotalWeightModal.vue?vue&type=style&index=0&id=345dd6b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345dd6b0"]])

export default __exports__